import { Routes } from '@angular/router';

import { environment } from '@environments/environment';
import { NewsOldComponent } from '../pages/news-old/news-old.component';

const NewsComponent = import('../pages/news/news.component');
const NewsDetailComponent = import(
  '../pages/news/news-detail/news-detail.component'
);

const viewOldVersion = !['dev', 'prod'].includes(environment.envName);

export const newsRoutes: Routes = viewOldVersion
  ? [
      {
        path: 'noticias',
        component: NewsOldComponent,
      },
      {
        path: 'noticias/:bullet/:channel',
        component: NewsOldComponent,
      },
    ]
  : [
      {
        path: 'news',
        loadComponent: () => NewsComponent,
      },
      {
        path: 'noticias',
        loadComponent: () => NewsComponent,
      },
      {
        path: 'news/:byUrl',
        loadComponent: () => NewsDetailComponent,
      },
      {
        path: 'noticias/:byUrl',
        loadComponent: () => NewsDetailComponent,
      },
    ];
